// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__DKtE+","containerFluid":"footer_containerFluid__T8n3u","stackedContent":"footer_stackedContent__0QQVm","socialMobile":"footer_socialMobile__vhaVG"};